/* eslint-disabled */

export default class BrownCardExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
